import React from 'react'

export default class TabContent extends React.Component {

  render() {
    return (
      <div>
        {this.props.content}
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/pages/AboutPages/tabs/tabcontent.js